import React from 'react'
import Header from '../Header/Header'
import './ViewMaster.css'
import Footer from '../Footer/Footer'

function ViewMaster(Component) {
    const NewComponent = (props) => {
        return <>
            <div className="gameHeader">
                <Header name={props.name} />
            </div>
            <Component {...props} />
            <Footer />
        </>
    }

    return NewComponent
}

export default ViewMaster